import React, { useEffect, useState, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  FaDownload,
  FaPlay,
  FaStar,
  FaCircle,
  FaChevronDown,
  FaChalkboardTeacher,
  FaChevronUp,
  FaCheck,
  FaComment,
  FaFileAlt,
  FaCertificate,
  FaTasks,
  FaThumbsUp,
  FaThumbsDown,
  FaReply,
  FaEdit,
  FaTrash,
  FaTimes,
  FaArrowLeft,
  FaEllipsisH,
} from 'react-icons/fa';
import { IoMdTime } from 'react-icons/io';
import defaultProfilePic from '../../assets/defaultProfilePic.png';
import api from '../../api';
import { getProfilePictureUrl } from '../../utils/apiHelper';
import './CourseOverview.css';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import Swal from 'sweetalert2';
import EnhancedVideoPlayer from '../VideoPlayerController/EnhancedVideoPlayer';
import { FaBars } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Certificate from '../CertificateGenerator/CertificateGenerator'; // adjust path as needed

const CourseOverview = () => {
  const { profile, profileLoading, token } = useAuth();
  const { courseId } = useParams();
  const location = useLocation(); // Get location to access navigation state
  const [course, setCourse] = useState(null);
  const [userName, setUserName] = useState('Learner');
  const [profilePicture, setProfilePicture] = useState();
  const [activeVideo, setActiveVideo] = useState(null);
  const [activeLessonId, setActiveLessonId] = useState(null);
  const [videoDurations, setVideoDurations] = useState({});
  const [watchedVideos, setWatchedVideos] = useState({});
  const [videoProgress, setVideoProgress] = useState({});
  const [progress, setProgress] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Add this line to fix the error
  const [activeTab, setActiveTab] = useState('content');
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [totalDuration, setTotalDuration] = useState(0);
  const [playedDuration, setPlayedDuration] = useState(0);
  const [videoTimeUpdate, setVideoTimeUpdate] = useState(0);
  const videoRef = useRef(null);
  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  const [ratingValue, setRatingValue] = useState(0);
  const [showTimeInfo, setShowTimeInfo] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [editingComment, setEditingComment] = useState(null);
  const [editText, setEditText] = useState('');
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [showMobileVideo, setShowMobileVideo] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [mobileOverlayTab, setMobileOverlayTab] = useState(null);
  const [seeAllDiscussion, setSeeAllDiscussion] = useState(false);
  const [allDiscussionPage, setAllDiscussionPage] = useState(1);
  const [allDiscussionPerPage] = useState(5); // Number of lessons per page
  const navigate = useNavigate();
  const playerRef = useRef(null);
  const [autoPlayNext, setAutoPlayNext] = useState(false);
  const [userRating, setUserRating] = useState(0); // State to store user input rating
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isInstructorRatingModalOpen, setIsInstructorRatingModalOpen] =
    useState(false); // State for modal
  const [selectedRating, setSelectedRating] = useState(0); // State for selected star rating
  const [instructorDetails, setInstructorDetails] = useState(null); // State for instructor details
  const [instructorBio, setInstructorBio] = useState('');
  const [isGiftModalOpen, setIsGiftModalOpen] = useState(false);
  const [giftEmail, setGiftEmail] = useState('');
  const [giftMessage, setGiftMessage] = useState('');
  const [isGiftSubmitting, setIsGiftSubmitting] = useState(false);
  const [hasShownAutoRating, setHasShownAutoRating] = useState(false);
  const [hasShownAutoRating80, setHasShownAutoRating80] = useState(false);
  const [userCourseRating, setUserCourseRating] = useState(null); // Add this state
  const [userInstructorRating, setUserInstructorRating] = useState(null);
  const [instructorRatingValue, setInstructorRatingValue] = useState(0);

  // Check localStorage to see if the modal has been shown
  useEffect(() => {
    const shown = localStorage.getItem('hasShownAutoRating');
    if (shown) {
      setHasShownAutoRating(true);
    }
  }, []);

  // Check localStorage to see if the 80% modal has been shown
  useEffect(() => {
    const shown80 = localStorage.getItem('hasShownAutoRating80');
    if (shown80) {
      setHasShownAutoRating80(true);
    }
  }, []);

  // Function to toggle dropdown visibility
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  // Handler for certificate button click
  const handleGetCertificateClick = () => {
    if (progress >= 95) {
      navigate(`/certificate/${courseId}`);
    } else {
      toast.info('Complete the course to unlock your certificate.');
    }
    setDropdownOpen(false);
  };

  // Handler for rate course button click
  const handleRateCourseClick = () => {
    setIsRatingModalOpen(true);
    setDropdownOpen(false);
    if (userCourseRating) setRatingValue(userCourseRating);
    localStorage.removeItem('hasShownAutoRating'); // Allow it to show again
  };

  // Handler for gift course button click
  const handleGiftCourseClick = () => {
    navigate(`/courses/${courseId}?openGift=true`);
    setDropdownOpen(false);
  };

  // Handler for gift course submission
  // const handleGiftSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsGiftSubmitting(true);

  //   try {
  //     const response = await api.post(
  //       "/api/courses/gift",
  //       {
  //         courseId,
  //         recipientEmail: giftEmail,
  //         message: giftMessage,
  //       },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     if (response.data.success) {
  //       toast.success("Course gifted successfully!");
  //       setIsGiftModalOpen(false);
  //       setGiftEmail("");
  //       setGiftMessage("");
  //     }
  //   } catch (error) {
  //     toast.error(
  //       error.response?.data?.message ||
  //         "Failed to gift the course. Please try again."
  //     );
  //   } finally {
  //     setIsGiftSubmitting(false);
  //   }
  // };

  // Define calculateProgress before it's used
  const calculateProgress = (courseData, watched, progressData = {}) => {
    if (!courseData?.sections) return;

    // Check if totalHours exists and is valid
    if (
      !courseData.totalHours ||
      isNaN(courseData.totalHours) ||
      courseData.totalHours <= 0
    ) {
      // console.warn('Invalid course total hours:', courseData.totalHours);
      setProgress(0);
      setPlayedDuration(0);
      setTotalDuration(0);
      return;
    }

    const totalSeconds = courseData.totalHours * 3600;

    // Sum up all watched durations from progress data
    const watchedSeconds = Object.values(progressData).reduce((acc, curr) => {
      const duration = curr?.watchedDuration || 0;
      return acc + (isNaN(duration) ? 0 : duration);
    }, 0);

    // console.log("Progress calculation:", { totalSeconds, watchedSeconds });

    const calculatedProgress =
      totalSeconds > 0
        ? Math.min(100, Math.round((watchedSeconds / totalSeconds) * 100))
        : 0;

    // console.log("Calculated progress:", calculatedProgress);

    setProgress(calculatedProgress);
    setPlayedDuration(watchedSeconds);
    setTotalDuration(totalSeconds);
  };

  const CertificateGenerator = () => {
    const { courseId } = useParams();

    // You can fetch course name and student name using courseId and context/auth
    const courseTitle = 'Advanced React'; // Replace with fetched data
    const studentName = 'John Doe'; // Replace with context/user info

    return (
      <div>
        <Certificate studentName={studentName} courseTitle={courseTitle} />
      </div>
    );
  };

  // Define playVideo function before it's used in useEffect
  const playVideo = async (lessonId, videoUrl, autoplay = false) => {
    // console.log("playVideo called with:", lessonId, videoUrl, "autoplay:", autoplay);

    if (!lessonId || !videoUrl) {
      // console.error('Invalid lesson ID or video URL:', { lessonId, videoUrl });
      return;
    }

    // Set state updates in a more controlled way
    setActiveVideo(videoUrl);
    setActiveLessonId(lessonId);
    setActiveTab('content');

    // console.log("After setting states - activeVideo:", videoUrl, "activeLessonId:", lessonId);

    if (isMobile) setShowMobileVideo(true);

    const lastPosition = videoProgress[lessonId]?.lastPosition || 0;

    try {
      const payload = {
        watchedDuration: lastPosition,
        duration: videoDurations[lessonId] || 0,
        lastPosition,
      };

      await axios.post(api.saveLessonProgress(courseId, lessonId), payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const updatedWatched = { ...watchedVideos, [lessonId]: true };
      setWatchedVideos(updatedWatched);
      calculateProgress(course, updatedWatched, videoProgress);

      // If autoplay is requested, set a flag that will be picked up by an effect
      if (autoplay) {
        sessionStorage.setItem('autoplay_video', 'true');
      }
    } catch (error) {
      console.error('Error saving progress:', error);
    }
  };

  // Handle window resize for mobile responsiveness
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // was 768
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // trigger immediately
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Toggle mobile video display
  const toggleMobileVideo = () => {
    setShowMobileVideo(!showMobileVideo);
    if (showMobileMenu) {
      setShowMobileMenu(false);
    }
  };

  // Create a ref for the resources section
  const resourcesRef = useRef(null);
  const mobileVideoRef = useRef(null);

  // Function to handle scrolling to the resources section
  const scrollToResources = () => {
    if (resourcesRef.current) {
      resourcesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const toggleMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  useEffect(() => {
    if (!profileLoading && profile) {
      const name = profile.name || 'Learner';
      setUserName(name);
      setProfilePicture(
        getProfilePictureUrl(profile.profilePicture, api.img, defaultProfilePic, name),
      );
    }
  }, [profile, profileLoading]);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        // Fetch course data
        const response = await axios.get(api.getCourseById(courseId));
        const courseData = response.data.course;
        setCourse(courseData);

        const initialExpandedState = {};
        courseData.sections.forEach(
          (_, idx) => (initialExpandedState[idx] = false),
        );

        // Fetch progress from backend
        const progressResponse = await axios.get(
          api.getCourseProgress(courseId),
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        // Log the raw response structure for debugging
        // console.log("Raw progress response:", JSON.stringify(progressResponse.data, null, 2));

        // Check if the lastPlayedLesson property exists at the root level
        const hasLastPlayedProperty =
          'lastPlayedLesson' in progressResponse.data;
        // console.log("Has lastPlayedLesson property:", hasLastPlayedProperty);

        // Examine alternative property names that might contain the data
        const possibleKeys = Object.keys(progressResponse.data).filter(
          (key) =>
            key.toLowerCase().includes('last') ||
            key.toLowerCase().includes('played') ||
            key.toLowerCase().includes('lesson'),
        );
        // console.log("Possible keys containing last played info:", possibleKeys);

        // Continue with your normal destructuring
        const {
          videoProgress: dbVideoProgress = {},
          lastPlayedLesson, // This should now correctly extract the lastPlayedLesson info
        } = progressResponse.data;

        // Create watchedVideos data from dbVideoProgress
        const dbWatchedVideos = {};
        Object.keys(dbVideoProgress).forEach((id) => {
          dbWatchedVideos[id] = dbVideoProgress[id].watched || false;
        });

        setWatchedVideos(dbWatchedVideos);
        setVideoProgress(dbVideoProgress);

        // Detailed log of the lastPlayedLesson object
        // console.log("lastPlayedLesson data:", lastPlayedLesson);
        if (lastPlayedLesson) {
          // console.log('lastPlayedLesson properties:', {
          //   hasLessonId: !!lastPlayedLesson.lessonId,
          //   lessonIdType: typeof lastPlayedLesson.lessonId,
          //   lastPosition: lastPlayedLesson.lastPosition || 0,
          // });
        } else {
          // console.log("lastPlayedLesson is null or undefined");
        }

        // Debug logs
        // console.log("Location state:", location?.state);
        // console.log("Last played from DB:", lastPlayedLesson);

        // Check if we have a lastPlayedVideoId from navigation state (Continue Learning button)
        const navigatedVideoId = location?.state?.lastPlayedVideoId;
        const navigatedVideoUrl = location?.state?.videoUrl; // Check if videoUrl was passed
        const navigatedPosition = location?.state?.lastPosition || 0;

        // console.log("Navigated video ID:", navigatedVideoId);
        // console.log("Navigated video URL:", navigatedVideoUrl);

        // Use navigatedVideoId if it exists, otherwise fallback to the lastPlayedLesson from database
        if (navigatedVideoId) {
          // If we already have the videoUrl from navigation state, use it
          if (navigatedVideoUrl) {
            // console.log("Using videoUrl from navigation state:", navigatedVideoUrl);
            playVideo(navigatedVideoId, navigatedVideoUrl);
            return;
          }

          // Otherwise find the video URL for the lesson ID from navigation
          let videoUrl = null;
          let foundSection = false;

          // First approach: Look through all sections and lessons to find the matching lesson
          for (const section of courseData.sections) {
            const lesson = section.lessons.find(
              (l) => l._id === navigatedVideoId,
            );
            if (lesson && lesson.video) {
              videoUrl = lesson.video;

              // Expand the section containing this lesson
              const sectionIndex = courseData.sections.indexOf(section);
              initialExpandedState[sectionIndex] = true;
              foundSection = true;
              // console.log("Found video for navigated ID:", videoUrl);
              break;
            }
          }

          // Backup approach: Flatten all lessons and find the matching one
          if (!videoUrl) {
            // console.log("First approach failed, trying backup method");
            const allLessons = courseData.sections.flatMap(
              (section) => section.lessons,
            );
            const lesson = allLessons.find((l) => l._id === navigatedVideoId);

            if (lesson && lesson.video) {
              videoUrl = lesson.video;
              videoUrl = lesson.video;
              // console.log("Found video using backup approach:", videoUrl);

              // Find which section contains this lesson
              for (let i = 0; i < courseData.sections.length; i++) {
                if (
                  courseData.sections[i].lessons.some(
                    (l) => l._id === navigatedVideoId,
                  )
                ) {
                  initialExpandedState[i] = true;
                  break;
                }
              }
            }
          }

          if (videoUrl) {
            // Play the video from navigation state
            // console.log("Playing video from navigation:", navigatedVideoId, videoUrl);
            playVideo(navigatedVideoId, videoUrl);

            // Update the last position if provided
            if (navigatedPosition > 0 && videoRef.current) {
              setTimeout(() => {
                if (videoRef.current) {
                  videoRef.current.currentTime = navigatedPosition;
                }
              }, 500); // Small delay to ensure video is loaded
            }
          } else {
            // console.log("Could not find video URL for ID:", navigatedVideoId);
          }
        }
        // If no navigation state but lastPlayedLesson from DB exists
        else if (lastPlayedLesson?.lessonId) {
          // console.log("Found lastPlayedLesson in DB:", lastPlayedLesson);

          // Try to find the video URL from the course data
          let lessonId = lastPlayedLesson.lessonId;
          let videoUrl = null;

          // Search through all sections and lessons to find the video URL
          for (const section of courseData.sections) {
            const lesson = section.lessons.find((l) => l._id === lessonId);
            if (lesson && lesson.video) {
              videoUrl = lesson.video;

              // Expand the section containing this lesson
              const sectionIndex = courseData.sections.indexOf(section);
              initialExpandedState[sectionIndex] = true;

              // console.log("Found videoUrl for lastPlayedLesson:", videoUrl);
              break;
            }
          }

          if (videoUrl) {
            // console.log("Playing video from lastPlayedLesson:", lessonId, videoUrl);
            playVideo(lessonId, videoUrl);

            // Set the playback position if available
            if (lastPlayedLesson.lastPosition > 0) {
              setTimeout(() => {
                if (videoRef.current) {
                  videoRef.current.currentTime = lastPlayedLesson.lastPosition;
                }
              }, 500);
            }
          } else {
            // console.log("Could not find videoUrl for lastPlayedLesson:", lessonId);
          }
        } else {
          // If we have neither, look for the first lesson with a video and play that
          // console.log("No last played video found, looking for first available video");

          // Find the first section with lessons
          for (const section of courseData.sections) {
            if (section.lessons && section.lessons.length > 0) {
              // Find the first lesson with a video
              const firstVideoLesson = section.lessons.find(
                (lesson) => lesson.video,
              );
              if (firstVideoLesson) {
                // console.log("Found first video lesson:", firstVideoLesson._id);

                // Expand the section
                const sectionIndex = courseData.sections.indexOf(section);
                initialExpandedState[sectionIndex] = true;

                // Play the video
                playVideo(firstVideoLesson._id, firstVideoLesson.video);
                break;
              }
            }
          }
        }

        setExpandedSections(initialExpandedState);
        calculateProgress(courseData, dbWatchedVideos, dbVideoProgress);
      } catch (error) {
        console.error('Error fetching course details or progress:', error);
      }
    };

    fetchCourseDetails();
  }, [courseId, token, location]);

  const getPreviousVideo = () => {
    if (!course?.sections || !activeLessonId) return null;
    let previousVideo = null;

    for (const section of course.sections) {
      for (const lesson of section.lessons) {
        if (lesson._id === activeLessonId) {
          return previousVideo;
        }
        if (lesson.video) {
          previousVideo = {
            videoUrl: lesson.video,
            lessonId: lesson._id,
          };
        }
      }
    }
    return null;
  };

  const playPreviousVideo = () => {
    const prevVideo = getPreviousVideo();
    if (prevVideo) {
      playVideo(prevVideo.lessonId, prevVideo.videoUrl);
    }
  };

  const ProgressCircleIcon = ({ progress }) => {
    return (
      <div className="cop-progress-circle-container">
        <FaCircle size={40} className="cop-progress-circle-icon" />
        <div className="cop-progress-circle-text">{progress}%</div>
      </div>
    );
  };

  const toggleSection = (sectionIndex) => {
    setExpandedSections((prev) => ({
      [sectionIndex]: !prev[sectionIndex],
    }));
  };

  useEffect(() => {
    if (course) {
      calculateProgress(course, watchedVideos, videoProgress);
    }
  }, [
    course,
    watchedVideos,
    videoProgress,
    videoDurations,
    activeLessonId,
    videoTimeUpdate,
  ]);

  const handleVideoLoadedMetadata = (lessonId, duration) => {
    setVideoDurations((prev) => ({
      ...prev,
      [lessonId]: duration, // Set the duration for the lesson
    }));
  };

  const lastUpdateRef = useRef(0); // Add at the top of your component

  const handleTimeUpdate = async (currentTime) => {
    const now = Date.now();
    if (now - lastUpdateRef.current < 5000) return; // throttle every 5s
    lastUpdateRef.current = now;

    setVideoTimeUpdate(currentTime);

    if (!activeLessonId) return;

    const duration = videoDurations[activeLessonId] || 0;
    const prevWatchedDuration =
      videoProgress[activeLessonId]?.watchedDuration || 0;

    const updatedWatchedDuration = Math.max(prevWatchedDuration, currentTime); // 👈 prevent rollback

    const updatedProgress = {
      ...videoProgress,
      [activeLessonId]: {
        watchedDuration: updatedWatchedDuration,
        duration,
        lastPosition: currentTime,
        watched: true,
        completed: updatedWatchedDuration >= duration, // ✅ mark completed if reached end
      },
    };

    setVideoProgress(updatedProgress);

    try {
      await axios.post(
        api.saveLessonProgress(courseId, activeLessonId), // ✅ use activeLessonId
        {
          watchedDuration: updatedWatchedDuration,
          duration,
          lastPosition: currentTime,
          videoUrl: activeVideo, // 🔥 this is needed by backend now
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
    } catch (error) {
      console.error('Error saving progress:', error);
    }

    calculateProgress(course, watchedVideos, updatedProgress);
  };

  const handleVideoEnded = async () => {
    // console.log("Video ended - handling based on player loop mode");

    if (activeLessonId) {
      const duration = videoDurations[activeLessonId] || 0;
      const newProgress = {
        ...videoProgress,
        [activeLessonId]: {
          watchedDuration: duration,
          duration: duration || 0,
          lastPosition: 0,
          completed: true, // Immediately mark the lesson as completed
        },
      };

      // Update the progress in the state
      setVideoProgress(newProgress);

      try {
        // Save progress to the backend
        await axios.post(
          api.saveLessonProgress(courseId, activeLessonId),
          {
            watchedDuration: duration || 0,
            duration: duration || 0,
            lastPosition: 0,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
      } catch (error) {
        console.error('Error saving progress:', error);
      }

      // Recalculate overall progress
      calculateProgress(course, watchedVideos, newProgress);
    }

    playNextVideo(); // The player will automatically play it if in 'next' mode
  };

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return '00:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '00:00:00';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return [
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      secs.toString().padStart(2, '0'),
    ].join(':');
  };

  const getNextVideo = () => {
    if (!course?.sections || !activeLessonId) return null;
    let foundCurrent = false;

    for (const section of course.sections) {
      for (const lesson of section.lessons) {
        if (foundCurrent && lesson.video) {
          return {
            videoUrl: lesson.video,
            lessonId: lesson._id,
          };
        }
        if (lesson._id === activeLessonId) {
          foundCurrent = true;
        }
      }
    }
    return null;
  };

  const formatRelativeTime = (timestamp) => {
    const now = new Date();
    const date = new Date(timestamp);
    const diffMs = now - date;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (seconds < 60) return 'just now';
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  };

  const playNextVideo = () => {
    // console.log("Playing next video");
    const nextVideo = getNextVideo();
    if (nextVideo) {
      // console.log("Found next video:", nextVideo);

      // Set autoPlay state to true before loading the next video
      setAutoPlayNext(true);

      playVideo(nextVideo.lessonId, nextVideo.videoUrl, true); // Pass autoplay flag

      // Try to play the video via the ref after a small delay to ensure it's loaded
      setTimeout(() => {
        if (playerRef.current) {
          // console.log("Attempting to play next video via ref");
          playerRef.current.play();
        }
      }, 800); // Slightly longer delay to ensure video has loaded
    } else {
      // console.log("No next video found");
    }
  };

  // Fetch comments when active lesson changes or seeAllDiscussion changes
  useEffect(() => {
    const fetchComments = async () => {
      if (seeAllDiscussion) {
        // Fetch all comments for the course
        try {
          setIsLoadingComments(true);
          const response = await axios.get(api.getAllCourseComments(courseId), {
            headers: { Authorization: `Bearer ${token}` },
          });
          // Flatten all comments into a single array for compatibility with existing UI logic
          const commentsByLesson = response.data.commentsByLesson || {};
          // Convert to array with lessonId property for each comment
          const allComments = Object.entries(commentsByLesson).flatMap(
            ([lessonId, comments]) =>
              comments.map((comment) => ({ ...comment, lessonId })),
          );
          setComments(allComments);
        } catch (error) {
          console.error('Error fetching all course comments:', error);
          setComments([]); // Set empty array on error
        } finally {
          setIsLoadingComments(false);
        }
      } else if (activeLessonId) {
        // Fetch comments for the active lesson only
        try {
          setIsLoadingComments(true);
          const response = await axios.get(
            api.getLessonComments(activeLessonId),
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          setComments(response.data.comments || []);
        } catch (error) {
          // Don't log this as an error since it's now a normal response
          // Just set empty comments array
          setComments([]);
        } finally {
          setIsLoadingComments(false);
        }
      }
    };
    fetchComments();
  }, [activeLessonId, token, seeAllDiscussion, courseId]);

  // Add keyboard event handlers for Enter key support
  const handleCommentKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleCommentSubmit(e);
    }
  };

  const handleReplyKeyDown = (e, commentId) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleReplySubmit(commentId);
    }
  };

  const handleEditKeyDown = (e, commentId) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleEditSubmit(commentId);
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();

    if (!newComment.trim()) {
      toast.error('Comment cannot be empty.', {
        className: 'custom-toast-error', // Custom error class
      });
      return;
    }

    try {
      const response = await axios.post(
        api.addLessonComment(activeLessonId),
        { text: newComment },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setComments([...comments, response.data.comment]);
      setNewComment('');
      toast.success('Comment added successfully!', {
        className: 'custom-toast', // Custom success class
      });
    } catch (error) {
      console.error('Error submitting comment:', error.response?.data || error.message);
      toast.error('Failed to post comment. Please try again.', {
        className: 'custom-toast-error', // Custom error class
      });
    }
  };

  const isRecentComment = (createdAt) => {
    const commentTime = new Date(createdAt).getTime();
    const currentTime = Date.now();
    return currentTime - commentTime < 5 * 60 * 1000; // 2 minutes = 120000 ms
  };

  // Submit a reply to a comment
  const handleReplySubmit = async (commentId) => {
    if (!replyText.trim()) {
      toast.error('Reply cannot be empty.');
      return;
    }

    try {
      const response = await axios.post(
        api.addReplyToComment(commentId), // Ensure this matches the backend route
        { text: replyText },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.status === 201) {
        // Update the UI with the new reply
        const updatedComment = response.data.comment;
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment._id === commentId ? updatedComment : comment,
          ),
        );
        setReplyText('');
        setReplyingTo(null);
        toast.success('Reply added successfully!', {
          className: 'custom-toast', // Apply custom success class
        });
      }
    } catch (error) {
      console.error('Error submitting reply:', error);
      toast.error('Failed to submit reply. Please try again.', {
        className: 'custom-toast-error', // Apply custom error class
      });
    }
  };

  const handleLikeComment = async (commentId) => {
    const comment = comments.find((c) => c._id === commentId);
    const isLiked = comment?.likes.includes(profile._id);

    try {
      await axios.post(
        api.likeComment(commentId),
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setComments((prev) =>
        prev.map((comment) => {
          if (comment._id === commentId) {
            // Toggle like - if already liked, remove it, otherwise add it and remove dislike
            const updatedLikes = isLiked
              ? comment.likes.filter((userId) => userId !== profile._id)
              : [...comment.likes, profile._id];

            const updatedDislikes = isLiked
              ? [...comment.dislikes] // No change to dislikes if unliking
              : comment.dislikes.filter((userId) => userId !== profile._id); // Remove dislike if liking

            return {
              ...comment,
              likes: updatedLikes,
              dislikes: updatedDislikes,
            };
          }
          return comment;
        }),
      );
    } catch (error) {
      console.error('Error toggling like:', error);
      toast.error('Failed to update like. Please try again.', {
        className: 'custom-toast-error', // Apply custom error class
      });
    }
  };

  const handleDislikeComment = async (commentId) => {
    const comment = comments.find((c) => c._id === commentId);
    const isDisliked = comment?.dislikes.includes(profile._id);

    try {
      await axios.post(
        api.dislikeComment(commentId),
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setComments((prev) =>
        prev.map((comment) => {
          if (comment._id === commentId) {
            // Toggle dislike - if already disliked, remove it, otherwise add it and remove like
            const updatedDislikes = isDisliked
              ? comment.dislikes.filter((userId) => userId !== profile._id)
              : [...comment.dislikes, profile._id];

            const updatedLikes = isDisliked
              ? [...comment.likes] // No change to likes if undisliking
              : comment.likes.filter((userId) => userId !== profile._id); // Remove like if disliking

            return {
              ...comment,
              likes: updatedLikes,
              dislikes: updatedDislikes,
            };
          }
          return comment;
        }),
      );
    } catch (error) {
      console.error('Error toggling dislike:', error);
      toast.error('Failed to update dislike. Please try again.', {
        className: 'custom-toast-error', // Apply custom error class
      });
    }
  };

  // Delete a comment
  const handleDeleteComment = async (commentId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(api.deleteComment(commentId), {
            headers: { Authorization: `Bearer ${token}` },
          });

          setComments(comments.filter((comment) => comment._id !== commentId));
          toast.success('Your comment has been deleted.', {
            className: 'custom-toast', // Apply custom success class
          });
        } catch (error) {
          console.error('Error deleting comment:', error);
          toast.error('Failed to delete comment. Please try again.', {
            className: 'custom-toast-error', // Apply custom error class
          });
        }
      }
    });
  };

  const startEditingComment = (comment) => {
    setEditingComment(comment._id);
    setEditText(comment.text);
  };

  const handleFirstPlay = async () => {
    try {
      const payload = {
        watchedDuration: 0,
        duration: videoDurations[activeLessonId] || 0,
        lastPosition: 0,
      };

      await axios.post(
        api.saveLessonProgress(courseId, activeLessonId),
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const updatedWatched = { ...watchedVideos, [activeLessonId]: true };
      setWatchedVideos(updatedWatched);
      calculateProgress(course, updatedWatched, videoProgress);
    } catch (error) {
      console.error('Live update error:', error);
    }
  };

  const handleEditSubmit = async (commentId) => {
    if (!editText.trim()) return;

    try {
      const response = await axios.patch(
        // ✅ PATCH instead of PUT
        api.updateComment(commentId),
        { text: editText },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setComments(
        comments.map((comment) =>
          comment._id === commentId ? response.data.comment : comment,
        ),
      );
      setEditingComment(null);
      setEditText('');
      toast.success('Comment updated successfully!', {
        className: 'custom-toast', // Apply custom success class
      });
    } catch (error) {
      console.error('Error editing comment:', error);
      toast.error('Failed to edit comment. Please try again.', {
        className: 'custom-toast-error', // Apply custom error class
      });
    }
  };

  useEffect(() => {
    if (activeTab === 'resources') {
      scrollToResources();
    }
  }, [activeTab]);

  // Add a dedicated effect for activeVideo changes to ensure the UI updates
  useEffect(() => {
    // console.log("activeVideo changed - activeVideo state:", activeVideo);
    if (activeVideo) {
      // Force an update to the state to ensure the component re-renders
      setActiveVideo(activeVideo);
    }
  }, [activeVideo]);

  // Add a dedicated effect for activeLessonId changes
  useEffect(() => {
    // console.log("activeLessonId changed - activeLessonId state:", activeLessonId);
    if (activeLessonId) {
      // Find the video for this lesson if activeVideo isn't set
      if (!activeVideo && course) {
        for (const section of course.sections) {
          const lesson = section.lessons.find((l) => l._id === activeLessonId);
          if (lesson && lesson.video) {
            // console.log("Found video for active lesson:", lesson.video);
            setActiveVideo(lesson.video);
            break;
          }
        }
      }
    }
  }, [activeLessonId, course]);

  // Add console logging right before return
  // console.log("Before rendering - activeVideo:", activeVideo);
  // console.log("Before rendering - activeLessonId:", activeLessonId);
  // console.log("Before rendering - showMobileVideo:", showMobileVideo);

  // Add an effect to reset autoPlayNext after video change
  useEffect(() => {
    if (activeVideo && autoPlayNext) {
      // Reset the autoPlayNext flag after a delay to ensure it's been used
      const timer = setTimeout(() => {
        setAutoPlayNext(false);
        // console.log("Reset autoPlayNext state");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [activeVideo, autoPlayNext]);

  // Add a new useEffect for progress recalculation
  useEffect(() => {
    // Recalculate progress whenever any of these dependencies change
    if (course && Object.keys(videoProgress).length > 0) {
      // console.log("Recalculating progress due to state changes");
      calculateProgress(course, watchedVideos, videoProgress);
    }
  }, [course, videoProgress, watchedVideos, videoDurations]);

  const handleRatingSubmit = async () => {
    if (userRating < 1 || userRating > 5) {
      alert('Please provide a rating between 1 and 5.');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await axios.post(
        api.rateInstructor,
        { instructorId: course.userId, rating: userRating },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      alert(response.data.message || 'Rating submitted successfully!');

      // Set localStorage flags to prevent auto popups
      localStorage.setItem('hasShownAutoRating', 'true');
      localStorage.setItem('hasShownAutoRating80', 'true');
    } catch (error) {
      console.error('Error submitting rating:', error);
      alert('Failed to submit rating. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInstructorRatingSubmit = async () => {
    try {
      setIsSubmitting(true);
      const response = await axios.post(
        api.rateInstructor,
        {
          instructorId: course.userId,
          rating: selectedRating,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.data) {
        setUserInstructorRating(selectedRating);
        setIsInstructorRatingModalOpen(false);
        setSelectedRating(0); // Reset rating after submission

        Swal.fire({
          title: 'Thank you!',
          text: 'Your rating for the instructor has been submitted successfully.',
          icon: 'success',
          confirmButtonText: 'Awesome!',
        });
      }
    } catch (error) {
      console.error('Error submitting instructor rating:', error);
      Swal.fire({
        title: 'Oops!',
        text: 'Could not submit your rating. Please try again later.',
        icon: 'error',
        confirmButtonText: 'Okay',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!course || !course.userId) return; // Only run if course and userId are present
    const fetchInstructorRatings = async () => {
      try {
        const response = await axios.get(
          api.getInstructorRatings(course.userId),
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setInstructorDetails(response.data.instructor);
      } catch (error) {
        console.error('Error fetching instructor ratings:', error);
      }
    };
    fetchInstructorRatings();
  }, [course, token]);

  useEffect(() => {
    if (!course || !course.userId) return;
    const fetchInstructorBio = async () => {
      try {
        const response = await axios.get(api.getInstructorBio(course.userId), {
          headers: { Authorization: `Bearer ${token}` },
        });
        setInstructorBio(response.data.bio || 'No bio available.');
      } catch (error) {
        setInstructorBio('No bio available.');
      }
    };
    fetchInstructorBio();
  }, [course, token]);

  // Add new useEffect for auto rating popup
  useEffect(() => {
    if (progress >= 50 && !hasShownAutoRating) {
      setIsRatingModalOpen(true);
      setHasShownAutoRating(true);
      localStorage.setItem('hasShownAutoRating', 'true'); // Set in localStorage
      if (userCourseRating) setRatingValue(userCourseRating);

      // Close the modal after 5 seconds
      const timer = setTimeout(() => {
        setIsRatingModalOpen(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [progress, hasShownAutoRating, userCourseRating]);

  // Add new useEffect for auto rating popup at 80%
  useEffect(() => {
    if (progress >= 80 && !hasShownAutoRating80) {
      setIsRatingModalOpen(true);
      setHasShownAutoRating80(true);
      localStorage.setItem('hasShownAutoRating80', 'true'); // Set in localStorage
      if (userCourseRating) setRatingValue(userCourseRating);

      // Close the modal after 5 seconds
      const timer = setTimeout(() => {
        setIsRatingModalOpen(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [progress, hasShownAutoRating80, userCourseRating]);

  // Content Protection - Prevent Screenshots, Screen Recording, and Copy
  useEffect(() => {
    // Prevent right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent keyboard shortcuts for copy, cut, paste, select all
    const handleKeyDown = (e) => {
      // Prevent Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+A, Ctrl+Z, Ctrl+Y
      if (e.ctrlKey || e.metaKey) {
        const key = e.key.toLowerCase();
        if (['c', 'x', 'v', 'a', 'z', 'y'].includes(key)) {
          // Allow copy/paste only in form inputs and textareas
          const target = e.target;
          const isFormElement = target.tagName === 'INPUT' || 
                               target.tagName === 'TEXTAREA' || 
                               target.contentEditable === 'true';

          if (!isFormElement) {
            e.preventDefault();
            return false;
          }
        }
      }

      // Prevent F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U (view source)
      if (e.key === 'F12' || 
          (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
          (e.ctrlKey && e.key === 'u')) {
        e.preventDefault();
        return false;
      }
    };

    // Prevent text selection
    const handleSelectStart = (e) => {
      const target = e.target;
      const isFormElement = target.tagName === 'INPUT' || 
                           target.tagName === 'TEXTAREA' || 
                           target.contentEditable === 'true';

      if (!isFormElement) {
        e.preventDefault();
        return false;
      }
    };

    // Prevent drag and drop
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent copy events
    const handleCopy = (e) => {
      const target = e.target;
      const isFormElement = target.tagName === 'INPUT' || 
                           target.tagName === 'TEXTAREA' || 
                           target.contentEditable === 'true';

      if (!isFormElement) {
        e.preventDefault();
        return false;
      }
    };

    // Prevent cut events
    const handleCut = (e) => {
      const target = e.target;
      const isFormElement = target.tagName === 'INPUT' || 
                           target.tagName === 'TEXTAREA' || 
                           target.contentEditable === 'true';

      if (!isFormElement) {
        e.preventDefault();
        return false;
      }
    };

    // Detect screen recording attempts (basic detection)
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Page is hidden, might be recording
        console.warn('Page visibility changed - potential screen recording detected');
      }
    };

    // Detect print attempts
    const handleBeforePrint = () => {
      window.location.href = '/learning'; // Redirect away from print
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCut);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeprint', handleBeforePrint);

    // Disable developer tools (basic attempt)
    const disableDevTools = () => {
      if (window.outerHeight - window.innerHeight > 200 || 
          window.outerWidth - window.innerWidth > 200) {
        // Developer tools might be open
        window.location.href = '/learning';
      }
    };

    // Check for developer tools periodically
    const devToolsInterval = setInterval(disableDevTools, 1000);

    // Cleanup function
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCut);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeprint', handleBeforePrint);
      clearInterval(devToolsInterval);
    };
  }, []);

  useEffect(() => {
    const fetchUserCourseRating = async () => {
      if (!courseId || !profile?._id) return;
      try {
        const res = await axios.get(api.getUserCourseRating(courseId, profile._id), {
          headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('Rating response:', res.data); // Add this for debugging
        if (res.data && typeof res.data.rating === 'number') {
          setUserCourseRating(res.data.rating);
          setRatingValue(res.data.rating);
        } else {
          setUserCourseRating(null);
          setRatingValue(0);
        }
      } catch (err) {
        console.error('Error fetching user rating:', err);
        setUserCourseRating(null);
        setRatingValue(0);
      }
    };
    fetchUserCourseRating();
  }, [courseId, profile?._id, token]);

  useEffect(() => {
    const fetchInstructorRating = async () => {
      if (!course?.userId || !profile?._id) return;
      try {
        const res = await axios.get(api.getInstructorRatings(course.userId), {
          headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('Instructor rating response:', res.data);
        if (res.data && res.data.instructor) {
          setUserInstructorRating(res.data.instructor.averageRating);
          setSelectedRating(res.data.instructor.averageRating); // Set the initial star rating
        }
      } catch (err) {
        console.error('Error fetching instructor rating:', err);
        setUserInstructorRating(null);
      }
    };
    fetchInstructorRating();
  }, [course?.userId, profile?._id, token]);

  if (!course) {
    return (
      <div className="cop-course-loading-container">
        <div className="cop-course-loading-spinner"></div>
        <p className="cop-course-loading-text">Loading course details...</p>
      </div>
    );
  }

  const {
    title = '',
    description = '',
    sections = [],
    instructorProfilePicture = 'Instructor',
    ratings = [],
    image = '',
  } = course || {};

  const ratingsCount = Array.isArray(ratings) ? ratings.length : 0;

  const averageRating =
    ratingsCount > 0
      ? (
        ratings.reduce((acc, rating) => acc + rating.rating, 0) / ratingsCount
      ).toFixed(2)
      : '0.00';

  const remainingDuration = course.totalHours * 3600 - playedDuration;

  const RatingModal = () => {
    const handleStarClick = (value) => {
      setRatingValue(value);
    };

    const handleRatingSubmit = async () => {
      try {
        const response = await axios.post(
          api.submitRating(courseId),
          { rating: ratingValue },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (response.data) {
          setUserCourseRating(ratingValue);
          setIsRatingModalOpen(false);

          Swal.fire({
            title: 'Thank you!',
            text: 'Your rating has been submitted successfully.',
            icon: 'success',
            confirmButtonText: 'Awesome!',
          });
        }
      } catch (error) {
        console.error('Error submitting rating:', error);
        Swal.fire({
          title: 'Oops!',
          text: 'Could not submit your rating. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Okay',
        });
      }
    };

    if (!isRatingModalOpen) return null;

    return (
      <div className="cop-modal-backdrop">
        <div className="course-rating-modal">
          <button
            className="course-rating-modal-close-button"
            onClick={() => setIsRatingModalOpen(false)}
          >
            ✕
          </button>
          <h2>How would you rate this course?</h2>
          <p className="cop-subtext">
            {{
              1: 'Terrible',
              2: 'Poor',
              3: 'Average',
              4: 'Good',
              5: 'Excellent',
            }[ratingValue] || 'Rate this course'}
          </p>

          <div className="stars">
            {[1, 2, 3, 4, 5].map((val) => (
              <span key={val} onClick={() => handleStarClick(val)}>
                {ratingValue >= val ? (
                  <FaStar className="star filled" />
                ) : (
                  <FaStar className="star" />
                )}
              </span>
            ))}
          </div>

          <button
            className="cop-submit-rating-button"
            onClick={handleRatingSubmit}
          >
            {userCourseRating ? 'Update Rating' : 'Submit Rating'}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="cop-modern-course-container">
      {/* Mobile header with More button */}
      {isMobile && !showMobileMenu && (
        <div className="cop-mobile-header">
          {/* Back button */}
          <button
            onClick={() => navigate('/learning')}
            className="cop-mobile-back-button"
          >
            <FaArrowLeft /> Back
          </button>

          {/* More menu button */}
          <button onClick={toggleMobileMenu} className="cop-mobile-menu-button">
            <FaBars /> More
          </button>
        </div>
      )}

      {/* Mobile menu overlay */}
      {isMobile && showMobileMenu && (
        <div className="cop-mobile-menu-overlay">
          <div className="cop-mobile-menu-content">
            <button
              onClick={() => {
                if (mobileOverlayTab) {
                  setMobileOverlayTab(null); // go back to menu
                } else {
                  setShowMobileMenu(false); // close full overlay
                }
              }}
              className="cop-mobile-menu-close"
            >
              {mobileOverlayTab ? <FaArrowLeft /> : <FaTimes />}{' '}
              {/* Icon changes here */}
              {mobileOverlayTab ? 'Back' : 'Close'}
            </button>
            {mobileOverlayTab && (
              <h2 className="cop-overlay-heading">
                {mobileOverlayTab.charAt(0).toUpperCase() +
                  mobileOverlayTab.slice(1)}
              </h2>
            )}

            {!mobileOverlayTab ? (
              <div className="cop-mobile-menu-tabs">
                <div
                  className="cop-mobile-menu-item"
                  onClick={() => setMobileOverlayTab('content')}
                >
                  Content
                </div>
                <div
                  className="cop-mobile-menu-item"
                  onClick={() => setMobileOverlayTab('resources')}
                >
                  Resources
                </div>
                <div
                  className="cop-mobile-menu-item"
                  onClick={() => setMobileOverlayTab('discussion')}
                >
                  Discussion
                </div>
                <div
                  className="cop-mobile-menu-item"
                  onClick={() => setMobileOverlayTab('assignment')}
                >
                  Assignment
                </div>
                <div
                  className="cop-mobile-menu-item"
                  onClick={() => setMobileOverlayTab('courseinstructor')}
                >
                  Course Instructor
                </div>
                <div
                  className="cop-mobile-menu-item"
                  onClick={() => {
                    setMobileOverlayTab('progress');
                  }}
                >
                  Progress
                </div>
              </div>
            ) : (
              <div className="cop-mobile-tab-overlay-content">
                {mobileOverlayTab === 'content' && (
                  <div className="cop-content-description">
                    <h3>About This Lesson</h3>
                    <div className="cop-progress-meta">
                      <div className="cop-meta-item">
                        <FaCertificate className="cop-meta-icon" />
                        <span>Certificate available at 100%</span>
                      </div>
                    </div>

                    {/* Current Lesson Info */}
                    {sections.map((section) => {
                      const currentLesson = section.lessons.find(
                        (lesson) => lesson._id === activeLessonId,
                      );
                      if (currentLesson) {
                        return (
                          <div key={section._id}>
                            <div className="cop-video-section-title">
                              Section: {section.name}
                            </div>
                            <div className="cop-video-lesson-title">
                              Lesson: {currentLesson.name}
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })}

                    {sections.map(
                      (section, idx) =>
                        section.lessons.find(
                          (lesson) => lesson._id === activeLessonId,
                        ) && (
                          <p key={section._id || idx}>
                            {description ||
                              'No description available for this lesson.'}
                          </p>
                        ),
                    )}
                  </div>
                )}
                {mobileOverlayTab === 'resources' && (
                  <div className="cop-resources-content" ref={resourcesRef}>
                    <h3>Lesson Resources</h3>
                    {sections.map((section) => {
                      const activeLesson = section.lessons.find(
                        (lesson) => lesson._id === activeLessonId,
                      );

                      if (!activeLesson) return null;

                      return (
                        <div
                          key={`${section._id}-${activeLesson._id}`}
                          className="cop-resources-grid"
                        >
                          {activeLesson.documents.length > 0 ? (
                            activeLesson.documents.map((doc) => (
                              <a
                                key={doc._id}
                                href={`${api.img + doc.file}`}
                                download
                                className="cop-resource-card"
                              >
                                <div className="cop-resource-icon">
                                  <FaFileAlt />
                                </div>
                                <div className="cop-resource-info">
                                  <h4>{doc.name}</h4>
                                  <span className="cop-resource-type">
                                    PDF • 2.4MB
                                  </span>
                                </div>
                                <div className="cop-download-button">
                                  <FaDownload />
                                </div>
                              </a>
                            ))
                          ) : (
                            <p className="cop-no-resources">
                              No resources available for this lesson.
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
                {mobileOverlayTab === 'discussion' && (
                  <div className="cop-discussion-content">
                    <h3>Lesson Discussion</h3>
                    <form
                      onSubmit={handleCommentSubmit}
                      className="cop-comment-form"
                    >
                      <img
                        src={profilePicture}
                        alt={userName}
                        className="cop-comment-avatar"
                      />
                      <input
                        type="text"
                        placeholder="Add a comment or question..."
                        value={newComment}
                        className="cop-input"
                        onChange={(e) => setNewComment(e.target.value)}
                        onKeyDown={handleCommentKeyDown}
                      />
                      <button type="submit" className="cop-submit-button">Post</button>
                    </form>

                    <div className="cop-comments-list">
                      {isLoadingComments ? (
                        <div className="cop-loading-comments">
                          <div className="spinner"></div>
                          Loading comments...
                        </div>
                      ) : comments.length > 0 ? (
                        comments.map((comment) => (
                          <div key={comment._id} className="cop-comment-card">
                            <img
                              src={getProfilePictureUrl(comment.userId.profilePicture, api.img, defaultProfilePic, comment.userId.name)}
                              alt={comment.userId.name}
                              className="cop-comment-avatar"
                            />
                            <div className="cop-comment-content">
                              <div className="cop-comment-header">
                                <h4>{comment.userId.name}</h4>
                                <span className="cop-comment-time">
                                  {formatRelativeTime(comment.createdAt)}
                                </span>
                              </div>

                              {editingComment === comment._id ? (
                                <div className="cop-comment-edit">
                                  <textarea
                                    value={editText}
                                    onChange={(e) =>
                                      setEditText(e.target.value)
                                    }
                                    onKeyDown={(e) => handleEditKeyDown(e, comment._id)}
                                    className="cop-textarea"
                                  />
                                  <div className="cop-comment-edit-actions">
                                    <button
                                      onClick={() =>
                                        handleEditSubmit(comment._id)
                                      }
                                      className="cop-save-button"
                                    >
                                      Save
                                    </button>
                                    <button
                                      onClick={() => setEditingComment(null)}
                                      className="cop-cancel-button"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <p>{comment.text}</p>
                                  <div className="cop-comment-actions">
                                    <button
                                      onClick={() =>
                                        handleLikeComment(comment._id)
                                      }
                                      className={`cop-like-button ${comment.likes.includes(profile._id)
                                        ? 'liked'
                                        : ''
                                      }`}
                                    >
                                      <FaThumbsUp />
                                      {comment.likes.length}
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleDislikeComment(comment._id)
                                      }
                                      className={`cop-dislike-button ${comment.dislikes.includes(profile._id)
                                        ? 'disliked'
                                        : ''
                                      }`}
                                    >
                                      <FaThumbsDown />
                                      {comment.dislikes.length}
                                    </button>
                                    <button
                                      onClick={() =>
                                        setReplyingTo(
                                          replyingTo === comment._id
                                            ? null
                                            : comment._id,
                                        )
                                      }
                                      className="cop-reply-button"
                                    >
                                      <FaReply /> Reply
                                    </button>
                                    {comment.userId._id === profile._id &&
                                      isRecentComment(comment.createdAt) && (
                                      <>
                                        <button
                                          onClick={() =>
                                            startEditingComment(comment)
                                          }
                                          className="cop-edit-button"
                                        >
                                          <FaEdit /> Edit
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDeleteComment(comment._id)
                                          }
                                          className="cop-delete-button"
                                        >
                                          <FaTrash /> Delete
                                        </button>
                                      </>
                                    )}
                                  </div>

                                  {replyingTo === comment._id && (
                                    <div className="cop-reply-form">
                                      <textarea
                                        placeholder="Write your reply..."
                                        value={replyText}
                                        onChange={(e) =>
                                          setReplyText(e.target.value)
                                        }
                                        onKeyDown={(e) => handleReplyKeyDown(e, comment._id)}
                                        className="cop-textarea"
                                      />
                                      <div className="cop-reply-actions">
                                        <button
                                          onClick={() =>
                                            handleReplySubmit(comment._id)
                                          }
                                          className="cop-submit-reply-button"
                                        >
                                          Post Reply
                                        </button>
                                        <button
                                          onClick={() => setReplyingTo(null)}
                                          className="cop-cancel-reply-button"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  {comment.replies.length > 0 && (
                                    <div className="cop-replies-list">
                                      {comment.replies.map((reply) => (
                                        <div
                                          key={reply._id || `${reply.userId._id}-${reply.createdAt}`}
                                          className="cop-reply-card"
                                        >
                                          <img
                                            src={getProfilePictureUrl(reply.userId.profilePicture, api.img, defaultProfilePic, reply.userId.name)}
                                            alt={reply.userId.name}
                                            className="cop-reply-avatar"
                                          />
                                          <div className="cop-reply-content">
                                            <div className="cop-reply-header">
                                              <h5>{reply.userId.name}</h5>
                                              <span className="cop-reply-time">
                                                {formatRelativeTime(
                                                  reply.createdAt,
                                                )}
                                              </span>
                                            </div>
                                            <p>{reply.text}</p>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="cop-no-comments">
                          No comments yet. Be the first to comment!
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {mobileOverlayTab === 'assignment' && (
                  <div className="cop-assignment-content">
                    {/* Reuse same assignment layout */}
                  </div>
                )}
                {mobileOverlayTab === 'courseinstructor' && (
                  <div className="cop-instructor-tab-content">
                    <div className="cop-instructor-card">
                      <div className="cop-instructor-header">
                        <h3>Course Instructor</h3>
                        <div className="cop-rating">
                          <FaStar className="cop-star-icon" />
                          <span>
                            {instructorDetails?.averageRating || 0} (
                            {instructorDetails?.totalRatings || 0} ratings)
                          </span>
                        </div>
                      </div>
                      <div
                        className="cop-instructor-profile"
                        onClick={() => navigate(`/instructor/${course.userId}`)} // Navigate to InstructorProfile with userId
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          src={getProfilePictureUrl(
                            course.instructorProfilePicture,
                            api.img,
                            defaultProfilePic,
                            course.instructor
                          )}
                          alt={course.instructor}
                          className="cop-instructor-profile-icon"
                        />
                        <div className="cop-instructor-info">
                          <p className="cd-course-instructor-name">
                            {course.instructor}
                          </p>
                          <p>{instructorBio}</p>
                        </div>
                      </div>
                      <div className="instructor-rating">
                        <button
                          className="cop-rate-instructor-button"
                          onClick={() => setIsInstructorRatingModalOpen(true)}
                        >
                          <FaStar style={{ color: '#fbbf24' }} /> Rate the
                          Instructor
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {mobileOverlayTab === 'progress' && (
                  <div className="cop-progress-time-info">
                    <h3>Your Progress</h3>
                    <div className="cop-time-info-item">
                      <span className="cop-time-label">Total Duration:</span>
                      <span className="cop-time-value">
                        {formatTime(course.totalHours * 3600)}
                      </span>
                    </div>
                    <div className="cop-time-info-item">
                      <span className="cop-time-label">Watched Duration:</span>
                      <span className="cop-time-value">
                        {formatTime(playedDuration)}
                      </span>
                    </div>
                    <div className="cop-time-info-item">
                      <span className="cop-time-label">
                        Remaining Duration:
                      </span>
                      <span className="cop-time-value">
                        {formatTime(
                          remainingDuration > 0 ? remainingDuration : 0,
                        )}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="cop-course-header">
        <div className="cop-header-content">
          <img
            src={logo}
            alt="UlsaApp Logo"
            className="cop-users-homelogo-img"
            onClick={() => {
              if (window.history.length > 2) {
                navigate(-1);
              } else {
                navigate('/learning');
              }
            }}
            style={{ cursor: 'pointer' }}
          />
          <div className="cop-header-row">
            <h1>{title}</h1>
            <div className="cop-hed-progress-circle-icon">
              <div className="cop-certificate-action">
                {/* 3 dot button */}
                <button
                  className="cop-options-button"
                  onClick={toggleDropdown}
                  aria-label="More options"
                >
                  ⋮
                </button>{' '}
                {/* Dropdown menu */}
                {dropdownOpen && (
                  <div className="cop-options-dropdown">
                    <button
                      className={`cop-get-certificate-button ${progress < 95 ? 'disabled' : ''
                      }`}
                      onClick={handleGetCertificateClick}
                      disabled={progress < 95}
                    >
                      🎓 Get Your Certificate
                    </button>
                    <button
                      className="cop-rate-course-button"
                      onClick={handleRateCourseClick}
                    >
                      <FaStar style={{ color: '#fbbf24', marginRight: 6 }} />
                      Rate this course
                    </button>
                    <button
                      className="cop-gift-course-button"
                      onClick={handleGiftCourseClick}
                    >
                      🎁 Gift this Course
                    </button>

                    <button
                      className="cop-course-details-button"
                      onClick={() => navigate(`/courses/${courseId}`)}
                    >
                      📘 Course Details
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cop-course-main">
        <div className="cop-course-sidebar">
          <div className="cop-sidebar-sections">
            {sections.map((section, sectionIndex) => (
              <div key={sectionIndex} className="cop-sidebar-section">
                <div
                  className="cop-section-header"
                  onClick={() => toggleSection(sectionIndex)}
                >
                  <div className="cop-section-title">
                    <span className="cop-section-number">
                      {sectionIndex + 1}
                    </span>
                    <h4>{section.name}</h4>
                  </div>
                  <div className="cop-section-toggle">
                    <span className="cop-lesson-count">
                      {section.lessons.length} lessons
                    </span>
                    {expandedSections[sectionIndex] ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </div>
                </div>

                {expandedSections[sectionIndex] && (
                  <div className="cop-section-lessons">
                    {section.lessons.map((lesson) => (
                      <div
                        key={lesson._id}
                        className={`cop-lesson-item ${activeLessonId === lesson._id ? 'active' : ''
                        } ${videoProgress[lesson._id]?.completed
                          ? 'completed'
                          : ''
                        }`}
                        onClick={() => {
                          if (lesson.video) {
                            playVideo(lesson._id, lesson.video);
                            setShowMobileMenu(false);
                            if (isMobile) {
                              setShowMobileVideo(true);
                              setTimeout(() => {
                                if (mobileVideoRef.current) {
                                  mobileVideoRef.current.scrollIntoView({
                                    behavior: 'smooth',
                                  });
                                }
                              }, 100);
                            }
                            // Trigger auto-play for the video
                            setTimeout(() => {
                              if (playerRef.current) {
                                playerRef.current.play();
                              }
                            }, 500); // Ensure the video is loaded before playing
                          }
                        }}
                      >
                        <div className="cop-lesson-icon">
                          {(() => {
                            const progress = videoProgress[lesson._id];
                            if (progress?.completed) {
                              return <FaCheck className="cop-completed-icon" />;
                            }
                            if (progress?.watched) {
                              return (
                                <FaEllipsisH className="cop-in-progress-icon" />
                              );
                            }
                            return <FaPlay className="cop-play-icon" />;
                          })()}
                        </div>
                        <div className="cop-lesson-info">
                          <h5>{lesson.name}</h5>
                          {lesson.documents && lesson.documents.length > 0 && (
                            <button
                              className="cop-resources-icon-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                playVideo(lesson._id, lesson.video);
                                setActiveTab('resources');
                                scrollToResources();
                              }}
                              title="View resources"
                            >
                              <FaFileAlt className="cop-resources-icon" />
                            </button>
                          )}{' '}
                          <br />
                          <div className="cop-lesson-duration">
                            {lesson.video && (
                              <video
                                src={`${api.img}${lesson.video}`}
                                className="cop-hidden-video"
                                onLoadedMetadata={(e) =>
                                  handleVideoLoadedMetadata(
                                    lesson._id,
                                    e.target.duration,
                                  )
                                }
                                preload="metadata"
                              />
                            )}
                            <span>
                              {lesson.video
                                ? watchedVideos[lesson._id]
                                  ? `${formatDuration(
                                    videoProgress[lesson._id]?.lastPosition ||
                                    videoProgress[lesson._id]
                                      ?.watchedDuration ||
                                    0,
                                  )} / ${formatDuration(
                                    videoDurations[lesson._id] || 0,
                                  )}`
                                  : formatDuration(
                                    videoDurations[lesson._id] || 0,
                                  )
                                : 'Reading'}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="cop-course-content">
          {/* Video Title Box */}
          {!isMobile && activeLessonId && (
            <div className="cop-video-title-box">
              {sections.map((section) => {
                const currentLesson = section.lessons.find(
                  (lesson) => lesson._id === activeLessonId,
                );
                if (currentLesson) {
                  return (
                    <div key={section._id}>
                      <div className="cop-video-section-title">
                        Section: {section.name}
                      </div>
                      <div className="cop-video-lesson-title">
                        Lesson: {currentLesson.name}
                      </div>
                      {/* <div className="cop-video-progress">Course Progress: <span className="cop-progress-value">{progress}%</span></div> */}
                    </div>
                  );
                }
                return null;
              })}
            </div>
          )}

          {/* Desktop Video Player */}
          {!isMobile && activeVideo && typeof activeVideo === 'string' && activeVideo.trim() !== '' ? (
            <div className="cop-video-container">
              <div className="cop-video-wrapper">
                <EnhancedVideoPlayer
                  ref={playerRef}
                  videoUrl={api.img + activeVideo}
                  onEnded={handleVideoEnded}
                  onTimeUpdate={handleTimeUpdate}
                  onNext={playNextVideo}
                  onPrevious={playPreviousVideo}
                  hasNext={!!getNextVideo()}
                  hasPrevious={!!getPreviousVideo()}
                  initialPosition={
                    videoProgress[activeLessonId]?.lastPosition ||
                    location?.state?.lastPosition ||
                    0
                  }
                  onPlayStart={handleFirstPlay}
                  autoPlay={autoPlayNext}
                />
              </div>
            </div>
          ) : null}

          {/* Welcome Screen (only shown when no lesson is selected) */}
          {!activeLessonId ? (
            <div className="cop-welcome-screen">
              <div className="cop-welcome-content">
                <div className="cop-welcome-icon">
                  <FaPlay />
                </div>
                <h2>Welcome</h2>
                <p>
                  Select a lesson from the sidebar to begin your learning
                  journey
                </p>
                <p className="cop-debug-info">
                  Last lesson ID: {activeLessonId || 'None'}
                </p>
                <p className="cop-debug-info">
                  Location state: {JSON.stringify(location?.state || {})}
                </p>
              </div>
            </div>
          ) : !activeVideo ? (
            <div className="cop-loading-container">
              <div className="cop-loading-spinner"></div>
              <p>Loading video...</p>
            </div>
          ) : (
            <div className="cop-debug-info" style={{ display: 'none' }}>
              Video loaded: {activeVideo ? 'Yes' : 'No'}
            </div>
          )}
          <div
            className="cop-progress-card"
            onClick={() => setShowTimeInfo((prev) => !prev)}
          >
            <div className="cop-progress-header">
              <h3 className="cop-progress-toggle-title">Your Progress</h3>
              <span className="cop-progress-percent">{progress}%</span>
              {showTimeInfo ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            <div className="cop-progress-bar">
              <div
                className="cop-progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            {showTimeInfo && (
              <div className="cop-progress-time-info">
                <div className="cop-time-info-item">
                  <span className="cop-time-label">Total Duration:</span>
                  <span className="cop-time-value">
                    {formatTime(course.totalHours * 3600)}
                  </span>
                </div>
                <div className="cop-time-info-item">
                  <span className="cop-time-label">Watched Duration:</span>
                  <span className="cop-time-value">
                    {formatTime(playedDuration)}
                  </span>
                </div>
                <div className="cop-time-info-item">
                  <span className="cop-time-label">Remaining Duration:</span>
                  <span className="cop-time-value">
                    {formatTime(remainingDuration > 0 ? remainingDuration : 0)}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="cop-content-tabs">
            <button
              className={`cop-tab-button ${activeTab === 'content' ? 'active' : ''
              }`}
              onClick={() => setActiveTab('content')}
            >
              <FaFileAlt className="cop-tab-icon" /> Content
            </button>
            <button
              className={`cop-tab-button ${activeTab === 'resources' ? 'active' : ''
              }`}
              onClick={() => setActiveTab('resources')}
            >
              <FaDownload className="cop-tab-icon" /> Resources
            </button>
            <button
              className={`cop-tab-button ${activeTab === 'discussion' ? 'active' : ''
              }`}
              onClick={() => setActiveTab('discussion')}
            >
              <FaComment className="cop-tab-icon" /> Discussion
            </button>
            <button
              className={`cop-tab-button ${activeTab === 'assignment' ? 'active' : ''
              }`}
              onClick={() => setActiveTab('assignment')}
            >
              <FaTasks className="cop-tab-icon" /> Assignment
            </button>
            <button
              className={`cop-tab-button ${activeTab === 'courseinstructor' ? 'active' : ''
              }`}
              onClick={() => setActiveTab('courseinstructor')}
            >
              <FaChalkboardTeacher className="cop-tab-icon" /> Course Instructor
            </button>
          </div>

          <div className="cop-tab-content">
            {activeTab === 'content' && (
              <div className="cop-content-description">
                <h3>About This Lesson</h3>
                <div className="cop-progress-meta">
                  <div className="cop-meta-item">
                    <FaCertificate className="cop-meta-icon" />
                    <span>Certificate available at 100%</span>
                  </div>
                </div>
                {sections.map(
                  (section, idx) =>
                    section.lessons.find(
                      (lesson) => lesson._id === activeLessonId,
                    ) && (
                      <p key={section._id || idx}>
                        {description ||
                          'No description available for this lesson.'}
                      </p>
                    ),
                )}
              </div>
            )}

            {activeTab === 'resources' && (
              <div className="cop-resources-content" ref={resourcesRef}>
                <h3>Lesson Resources</h3>
                {sections.map((section) => {
                  const activeLesson = section.lessons.find(
                    (lesson) => lesson._id === activeLessonId,
                  );

                  if (!activeLesson) return null;

                  return (
                    <div
                      key={`${section._id}-${activeLesson._id}-resources`}
                      className="cop-resources-grid"
                    >
                      {activeLesson.documents.length > 0 ? (
                        activeLesson.documents.map((doc) => (
                          <a
                            key={doc._id}
                            href={`${api.img + doc.file}`}
                            download
                            className="cop-resource-card"
                          >
                            <div className="cop-resource-icon">
                              <FaFileAlt />
                            </div>
                            <div className="cop-resource-info">
                              <h4>{doc.name}</h4>
                              <span className="cop-resource-type">
                                PDF • 2.4MB
                              </span>
                            </div>
                            <div className="cop-download-button">
                              <FaDownload />
                            </div>
                          </a>
                        ))
                      ) : (
                        <p className="cop-no-resources">
                          No resources available for this lesson.
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {activeTab === 'discussion' && (
              <div className="cop-discussion-content">
                <h3>
                  {seeAllDiscussion ? 'Course Discussion' : 'Lesson Discussion'}
                </h3>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 12,
                  }}
                >
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      fontSize: 14,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={seeAllDiscussion}
                      onChange={(e) => {
                        setSeeAllDiscussion(e.target.checked);
                        setAllDiscussionPage(1); // Reset page on toggle
                      }}
                      style={{ marginRight: 6 }}
                    />
                    See All Discussion
                  </label>
                </div>
                <form
                  onSubmit={handleCommentSubmit}
                  className="cop-comment-form"
                >
                  <img
                    src={profilePicture}
                    alt={userName}
                    className="cop-comment-avatar"
                  />
                  <input
                    type="text"
                    placeholder="Add a comment or question..."
                    value={newComment}
                    className="cop-input"
                    onChange={(e) => setNewComment(e.target.value)}
                    onKeyDown={handleCommentKeyDown}
                  />
                  <button type="submit" className="cop-submit-button">Post</button>
                </form>
                <div className="cop-comments-list">
                  {isLoadingComments ? (
                    <div className="cop-loading-comments">
                      <div className="spinner"></div>
                      Loading comments...
                    </div>
                  ) : seeAllDiscussion ? (
                    (() => {
                      // Gather all lessons with comments
                      const lessonsWithComments = sections
                        .flatMap((section) =>
                          section.lessons.map((lesson) => {
                            const lessonComments = comments.filter(
                              (c) => c.lessonId === lesson._id,
                            );
                            if (lessonComments.length === 0) return null;
                            return { section, lesson, lessonComments };
                          }),
                        )
                        .filter(Boolean);
                      // Pagination
                      const start = (allDiscussionPage - 1) * allDiscussionPerPage;
                      const end = start + allDiscussionPerPage;
                      const paginatedLessons = lessonsWithComments.slice(start, end);

                      return paginatedLessons.length > 0 ? (
                        <>
                          {paginatedLessons.map(({ section, lesson, lessonComments }) => (
                            <div key={lesson._id} style={{ marginBottom: 24 }}>
                              <div
                                style={{
                                  fontWeight: 600,
                                  color: '#4f46e5',
                                  marginBottom: 6,
                                }}
                              >
                                Section: {section.name} &nbsp;|&nbsp; Lesson:{' '}
                                {lesson.name}
                              </div>
                              {lessonComments.map((comment) => (
                                <div
                                  key={comment._id}
                                  className="cop-comment-card"
                                >
                                  <img
                                    src={getProfilePictureUrl(comment.userId.profilePicture, api.img, defaultProfilePic, comment.userId.name)}
                                    alt={comment.userId.name}
                                    className="cop-comment-avatar"
                                  />
                                  <div className="cop-comment-content">
                                    <div className="cop-comment-header">
                                      <h4>{comment.userId.name}</h4>
                                      <span className="cop-comment-time">
                                        {formatRelativeTime(
                                          comment.createdAt,
                                        )}
                                      </span>
                                    </div>
                                    {editingComment === comment._id ? (
                                      <div className="cop-comment-edit">
                                        <textarea
                                          value={editText}
                                          onChange={(e) =>
                                            setEditText(e.target.value)
                                          }
                                          onKeyDown={(e) => handleEditKeyDown(e, comment._id)}
                                          className="cop-textarea"
                                        />
                                        <div className="cop-comment-edit-actions">
                                          <button
                                            onClick={() =>
                                              handleEditSubmit(comment._id)
                                            }
                                            className="cop-save-button"
                                          >
                                            Save
                                          </button>
                                          <button
                                            onClick={() => setEditingComment(null)}
                                            className="cop-cancel-button"
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <p>{comment.text}</p>
                                        <div className="cop-comment-actions">
                                          <button
                                            onClick={() =>
                                              handleLikeComment(comment._id)
                                            }
                                            className={`cop-like-button ${comment.likes.includes(
                                              profile._id,
                                            )
                                              ? 'liked'
                                              : ''
                                            }`}
                                          >
                                            <FaThumbsUp />
                                            {comment.likes.length}
                                          </button>
                                          <button
                                            onClick={() =>
                                              handleDislikeComment(
                                                comment._id,
                                              )
                                            }
                                            className={`cop-dislike-button ${comment.dislikes.includes(
                                              profile._id,
                                            )
                                              ? 'disliked'
                                              : ''
                                            }`}
                                          >
                                            <FaThumbsDown />
                                            {comment.dislikes.length}
                                          </button>
                                          <button
                                            onClick={() =>
                                              setReplyingTo(
                                                replyingTo === comment._id
                                                  ? null
                                                  : comment._id,
                                              )
                                            }
                                            className="cop-reply-button"
                                          >
                                            <FaReply /> Reply
                                          </button>
                                          {comment.userId._id ===
                                            profile._id &&
                                            isRecentComment(
                                              comment.createdAt,
                                            ) && (
                                            <>
                                              <button
                                                onClick={() =>
                                                  startEditingComment(
                                                    comment,
                                                  )
                                                }
                                                className="cop-edit-button"
                                              >
                                                <FaEdit /> Edit
                                              </button>
                                              <button
                                                onClick={() =>
                                                  handleDeleteComment(
                                                    comment._id,
                                                  )
                                                }
                                                className="cop-delete-button"
                                              >
                                                <FaTrash /> Delete
                                              </button>
                                            </>
                                          )}
                                        </div>
                                        {replyingTo === comment._id && (
                                          <div className="cop-reply-form">
                                            <textarea
                                              placeholder="Write your reply..."
                                              value={replyText}
                                              onChange={(e) =>
                                                setReplyText(e.target.value)
                                              }
                                              onKeyDown={(e) => handleReplyKeyDown(e, comment._id)}
                                              className="cop-textarea"
                                            />
                                            <div className="cop-reply-actions">
                                              <button
                                                onClick={() =>
                                                  handleReplySubmit(
                                                    comment._id,
                                                  )
                                                }
                                                className="cop-submit-reply-button"
                                              >
                                                Post Reply
                                              </button>
                                              <button
                                                onClick={() =>
                                                  setReplyingTo(null)
                                                }
                                                className="cop-cancel-reply-button"
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                        {comment.replies.length > 0 && (
                                          <div className="cop-replies-list">
                                            {comment.replies.map(
                                              (reply) => (
                                                <div
                                                  key={reply._id || `${reply.userId._id}-${reply.createdAt}`}
                                                  className="cop-reply-card"
                                                >
                                                  <img
                                                    src={
                                                      getProfilePictureUrl(reply.userId.profilePicture, api.img, defaultProfilePic, reply.userId.name)
                                                    }
                                                    alt={reply.userId.name}
                                                    className="cop-reply-avatar"
                                                  />
                                                  <div className="cop-reply-content">
                                                    <div className="cop-reply-header">
                                                      <h5>
                                                        {reply.userId.name}
                                                      </h5>
                                                      <span className="cop-reply-time">
                                                        {formatRelativeTime(
                                                          reply.createdAt,
                                                        )}
                                                      </span>
                                                    </div>
                                                    <p>{reply.text}</p>
                                                  </div>
                                                </div>
                                              ),
                                            )}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div style={{ textAlign: 'center', marginTop: 16 }}>
                                {end < lessonsWithComments.length && (
                                  <button
                                    className="cop-more-comments-button"
                                    onClick={() =>
                                      setAllDiscussionPage(allDiscussionPage + 1)
                                    }
                                    style={{
                                      padding: '6px 18px',
                                      borderRadius: 6,
                                      background: '#4f46e5',
                                      color: '#fff',
                                      border: 'none',
                                      cursor: 'pointer',
                                      fontWeight: 500,
                                    }}
                                  >
                                    More...
                                  </button>
                                )}
                                {allDiscussionPage > 1 && (
                                  <button
                                    className="cop-more-comments-button"
                                    onClick={() =>
                                      setAllDiscussionPage(allDiscussionPage - 1)
                                    }
                                    style={{
                                      padding: '6px 18px',
                                      borderRadius: 6,
                                      background: '#e5e7eb',
                                      color: '#222',
                                      border: 'none',
                                      cursor: 'pointer',
                                      fontWeight: 500,
                                      marginLeft: 8,
                                    }}
                                  >
                                    Previous
                                  </button>
                                )}
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className="cop-no-comments">
                          No comments yet. Be the first to comment!
                        </p>
                      );
                    })()
                  ) : comments.filter(
                    (comment) => comment.lessonId === activeLessonId,
                  ).length > 0 ? (
                      comments
                        .filter((comment) => comment.lessonId === activeLessonId)
                        .map((comment) => (
                        // ...existing code for rendering a comment card for the current lesson...
                          <div key={comment._id} className="cop-comment-card">
                            <img
                              src={getProfilePictureUrl(comment.userId.profilePicture, api.img, defaultProfilePic, comment.userId.name)}
                              alt={comment.userId.name}
                              className="cop-comment-avatar"
                            />
                            <div className="cop-comment-content">
                              <div className="cop-comment-header">
                                <h4>{comment.userId.name}</h4>
                                <span className="cop-comment-time">
                                  {formatRelativeTime(comment.createdAt)}
                                </span>
                              </div>
                              {editingComment === comment._id ? (
                                <div className="cop-comment-edit">
                                  <textarea
                                    value={editText}
                                    onChange={(e) => setEditText(e.target.value)}
                                    onKeyDown={(e) => handleEditKeyDown(e, comment._id)}
                                    className="cop-textarea"
                                  />
                                  <div className="cop-comment-edit-actions">
                                    <button
                                      onClick={() =>
                                        handleEditSubmit(comment._id)
                                      }
                                      className="cop-save-button"
                                    >
                                    Save
                                    </button>
                                    <button
                                      onClick={() => setEditingComment(null)}
                                      className="cop-cancel-button"
                                    >
                                    Cancel
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <p>{comment.text}</p>
                                  <div className="cop-comment-actions">
                                    <button
                                      onClick={() =>
                                        handleLikeComment(comment._id)
                                      }
                                      className={`cop-like-button ${comment.likes.includes(profile._id)
                                        ? 'liked'
                                        : ''
                                      }`}
                                    >
                                      <FaThumbsUp />
                                      {comment.likes.length}
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleDislikeComment(comment._id)
                                      }
                                      className={`cop-dislike-button ${comment.dislikes.includes(profile._id)
                                        ? 'disliked'
                                        : ''
                                      }`}
                                    >
                                      <FaThumbsDown />
                                      {comment.dislikes.length}
                                    </button>
                                    <button
                                      onClick={() =>
                                        setReplyingTo(
                                          replyingTo === comment._id
                                            ? null
                                            : comment._id,
                                        )
                                      }
                                      className="cop-reply-button"
                                    >
                                      <FaReply /> Reply
                                    </button>
                                    {comment.userId._id === profile._id &&
                                    isRecentComment(comment.createdAt) && (
                                      <>
                                        <button
                                          onClick={() =>
                                            startEditingComment(comment)
                                          }
                                          className="cop-edit-button"
                                        >
                                          <FaEdit /> Edit
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDeleteComment(comment._id)
                                          }
                                          className="cop-delete-button"
                                        >
                                          <FaTrash /> Delete
                                        </button>
                                      </>
                                    )}
                                  </div>
                                  {replyingTo === comment._id && (
                                    <div className="cop-reply-form">
                                      <textarea
                                        placeholder="Write your reply..."
                                        value={replyText}
                                        onChange={(e) =>
                                          setReplyText(e.target.value)
                                        }
                                        onKeyDown={(e) => handleReplyKeyDown(e, comment._id)}
                                        className="cop-textarea"
                                      />
                                      <div className="cop-reply-actions">
                                        <button
                                          onClick={() =>
                                            handleReplySubmit(comment._id)
                                          }
                                          className="cop-submit-reply-button"
                                        >
                                        Post Reply
                                        </button>
                                        <button
                                          onClick={() => setReplyingTo(null)}
                                          className="cop-cancel-reply-button"
                                        >
                                        Cancel
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  {comment.replies.length > 0 && (
                                    <div className="cop-replies-list">
                                      {comment.replies.map((reply) => (
                                        <div
                                          key={reply._id || `${reply.userId._id}-${reply.createdAt}`}
                                          className="cop-reply-card"
                                        >
                                          <img
                                            src={getProfilePictureUrl(reply.userId.profilePicture, api.img, defaultProfilePic, reply.userId.name)}
                                            alt={reply.userId.name}
                                            className="cop-reply-avatar"
                                          />
                                          <div className="cop-reply-content">
                                            <div className="cop-reply-header">
                                              <h5>{reply.userId.name}</h5>
                                              <span className="cop-reply-time">
                                                {formatRelativeTime(
                                                  reply.createdAt,
                                                )}
                                              </span>
                                            </div>
                                            <p>{reply.text}</p>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        ))
                    ) : (
                      <p className="cop-no-comments">
                      No comments yet. Be the first to comment!
                      </p>
                    )}
                </div>
              </div>
            )}

            {activeTab === 'assignment' && (
              <div className="cop-assignment-content">
                <h3>Lesson Assignment</h3>
                {sections.map((section) => {
                  const lessonWithAssignment = section.lessons.find(
                    (lesson) =>
                      lesson._id === activeLessonId && lesson.assignment,
                  );

                  if (!lessonWithAssignment) return null;

                  return (
                    <div
                      key={`${section._id}-assignment`}
                      className="cop-assignment-card"
                    >
                      <div className="cop-assignment-header">
                        <h4>{lessonWithAssignment.assignment.title}</h4>
                        <span className="cop-assignment-status submitted">
                          Submitted
                        </span>
                      </div>
                      <p>{lessonWithAssignment.assignment.description}</p>
                      <div className="cop-assignment-due">
                        <IoMdTime className="cop-due-icon" />
                        <span>Due in 3 days</span>
                      </div>
                      <div className="cop-assignment-actions">
                        <button className="cop-primary-button">
                          View Submission
                        </button>
                        <button className="cop-secondary-button">
                          Resubmit
                        </button>
                      </div>
                    </div>
                  );
                })}
                {!sections.some((section) =>
                  section.lessons.some(
                    (lesson) =>
                      lesson._id === activeLessonId && lesson.assignment,
                  ),
                ) && (
                  <p className="cop-no-assignment">
                      No assignment for this lesson.
                  </p>
                )}
              </div>
            )}

            {activeTab === 'courseinstructor' && (
              <div className="cop-instructor-tab-content">
                <div className="cop-instructor-card">
                  <div className="cop-instructor-header">
                    <h3>Course Instructor</h3>
                    <div className="instructor-rating">
                      <FaStar className="cop-star-icon" />
                      <span>
                        {instructorDetails?.averageRating || 0} (
                        {instructorDetails?.totalRatings || 0} ratings)
                      </span>
                    </div>
                  </div>
                  <div
                    className="cop-instructor-profile"
                    onClick={() => navigate(`/instructor/${course.userId}`)} // Navigate to InstructorProfile with userId
                    style={{ cursor: 'pointer' }}
                  >
                    <img
                      src={getProfilePictureUrl(
                        course.instructorProfilePicture,
                        api.img,
                        defaultProfilePic,
                        course.instructor
                      )}
                      alt={course.instructor}
                      className="cop-instructor-profile-icon"
                    />
                    <div className="cop-instructor-info">
                      <p className="cd-course-instructor-name">
                        {course.instructor}
                      </p>
                      <p>{instructorBio}</p>
                    </div>
                  </div>
                  <div className="instructor-rating">
                    <button
                      className="cop-rate-instructor-button"
                      onClick={() => setIsInstructorRatingModalOpen(true)}
                    >
                      <FaStar style={{ color: '#fbbf24' }} /> Rate the
                      Instructor
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile video wrapper */}
      {isMobile && activeVideo && typeof activeVideo === 'string' && activeVideo.trim() !== '' && (
        <div className="cop-mobile-video-wrapper" ref={mobileVideoRef}>
          {/* Video player or trigger button - Now first */}
          {!showMobileVideo ? (
            <button className="cop-mobile-video-trigger" onClick={toggleMobileVideo}>
              <FaPlay /> Watch Video
            </button>
          ) : (
            <div
              className={`cop-mobile-video-container ${showMobileVideo ? 'fixed' : ''
              }`}
            >
              {/* Mobile Video Title Box - Now second */}
              {activeLessonId && (
                <div className="cop-video-title-box">
                  {sections.map((section) => {
                    const currentLesson = section.lessons.find(
                      (lesson) => lesson._id === activeLessonId,
                    );
                    if (currentLesson) {
                      return (
                        <div key={section._id}>
                          <div className="cop-video-section-title">
                            Section: {section.name}
                          </div>
                          <div className="cop-video-lesson-title">
                            Lesson: {currentLesson.name}
                          </div>
                          {/* <div className="cop-video-progress">Course Progress: <span className="cop-progress-value">{progress}%</span></div> */}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              )}
              <div className="cop-mobile-video-header">
                <button
                  className="cop-mobile-video-close"
                  onClick={toggleMobileVideo}
                >
                  <FaTimes />
                </button>
              </div>
              <div className="cop-video-wrapper">
                <EnhancedVideoPlayer
                  ref={playerRef}
                  videoUrl={api.img + activeVideo}
                  onEnded={handleVideoEnded}
                  onTimeUpdate={handleTimeUpdate}
                  onNext={playNextVideo}
                  onPrevious={playPreviousVideo}
                  hasNext={!!getNextVideo()}
                  hasPrevious={!!getPreviousVideo()}
                  initialPosition={
                    videoProgress[activeLessonId]?.lastPosition ||
                    location?.state?.lastPosition ||
                    0
                  }
                  size={isMobile ? 'small' : 'default'}
                  autoPlay={autoPlayNext}
                />
              </div>
            </div>
          )}
        </div>
      )}

      {/* Mobile video spacer */}
      {isMobile && showMobileVideo && activeVideo && (
        <div className="cop-mobile-video-spacer">dsd</div>
      )}

      <div className="cop-sidebar-sections-mobile">
        {sections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="section-wrapper">


            <div
              className="cop-section-header"
              onClick={() => toggleSection(sectionIndex)}
            >
              <div className="cop-section-title">
                <span className="cop-section-number">{sectionIndex + 1}</span>
                <h4>{section.name}</h4>
              </div>
              <div className="section-toggle">
                <span className="lesson-count">
                  {section.lessons.length} lessons
                </span>
                {expandedSections[sectionIndex] ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}
              </div>
            </div>

            {expandedSections[sectionIndex] && (
              <div className="section-lessons">
                {section.lessons.map((lesson) => (
                  <div
                    key={lesson._id}
                    className={`lesson-item ${activeLessonId === lesson._id ? 'active' : ''
                    } ${watchedVideos[lesson._id] ? 'completed' : ''}`}
                    onClick={() => {
                      if (lesson.video) {
                        playVideo(lesson._id, lesson.video);
                        setShowMobileMenu(false);
                        if (isMobile) {
                          setShowMobileVideo(true);
                          setTimeout(() => {
                            if (mobileVideoRef.current) {
                              mobileVideoRef.current.scrollIntoView({
                                behavior: 'smooth',
                              });
                            }
                          }, 100);
                        }
                        // Trigger auto-play for the video
                        setTimeout(() => {
                          if (playerRef.current) {
                            playerRef.current.play();
                          }
                        }, 500); // Ensure the video is loaded before playing
                      }
                    }}
                  >
                    <div className="lesson-icon">
                      {(() => {
                        const progress = videoProgress[lesson._id];
                        if (progress?.completed) {
                          return <FaCheck className="cop-completed-icon" />;
                        }
                        if (progress?.watched) {
                          return (
                            <FaEllipsisH className="cop-in-progress-icon" />
                          );
                        }
                        return <FaPlay className="cop-play-icon" />;
                      })()}
                    </div>
                    <div className="lesson-info">
                      <h5>{lesson.name}</h5>
                      {lesson.documents && lesson.documents.length > 0 && (
                        <button
                          className="resources-icon-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            playVideo(lesson._id, lesson.video);
                            setActiveTab('resources');
                            scrollToResources();
                          }}
                          title="View resources"
                        >
                          <FaFileAlt className="resources-icon" />
                        </button>
                      )}{' '}
                      <br />
                      <div className="lesson-duration">
                        {lesson.video && typeof lesson.video === 'string' && lesson.video.trim() !== '' && (
                          <video
                            src={`${api.img}${lesson.video}`}
                            className="cop-hidden-video"
                            onLoadedMetadata={(e) =>
                              handleVideoLoadedMetadata(
                                lesson._id,
                                e.target.duration,
                              )
                            }
                            preload="metadata"
                          />
                        )}
                        <span>
                          {lesson.video
                            ? watchedVideos[lesson._id]
                              ? `${formatDuration(
                                videoProgress[lesson._id]?.lastPosition ||
                                videoProgress[lesson._id]
                                  ?.watchedDuration ||
                                0,
                              )} / ${formatDuration(
                                videoDurations[lesson._id] || 0,
                              )}`
                              : formatDuration(
                                videoDurations[lesson._id] || 0,
                              )
                            : 'Reading'}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <RatingModal />

      {/* Instructor Rating Modal */}
      {isInstructorRatingModalOpen && (
        <div className="instructor-rating-modal-overlay">
          <div className="instructor-rating-modal-content">
            <h3>Rate the Instructor</h3>
            <div className="instructor-rating-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  className={`instructor-rating-star ${selectedRating >= star ? 'selected' : ''
                  }`}
                  onClick={() => setSelectedRating(star)}
                  style={{
                    cursor: 'pointer',
                    color: selectedRating >= star ? '#fbbf24' : '#ccc',
                  }}
                />
              ))}
            </div>
            <button
              onClick={handleInstructorRatingSubmit}
              disabled={isSubmitting}
              className="instructor-submit-rating-button"
            >
              {isSubmitting ? 'Submitting...' : userInstructorRating ? 'Update Rating' : 'Submit Rating'}
            </button>
            <button
              onClick={() => {
                setIsInstructorRatingModalOpen(false);
                setSelectedRating(userInstructorRating || 0); // Reset to previous rating when closing
              }}
              className="instructor-cancel-rating-button"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Gift Course Modal */}
      {isGiftModalOpen && (
        <div className="cop-modal-backdrop">
          <div className="cop-modal">
            <div className="cop-modal-header">
              <h3>Gift this Course</h3>
              <button
                className="cop-modal-close"
                onClick={() => setIsGiftModalOpen(false)}
              >
                <FaTimes />
              </button>
            </div>
            {/* <form onSubmit={handleGiftSubmit} className="cop-gift-form">
              <div className="cop-form-group">
                <label htmlFor="giftEmail">Recipient's Email</label>
                <input
                  type="email"
                  id="giftEmail"
                  value={giftEmail}
                  onChange={(e) => setGiftEmail(e.target.value)}
                  required
                  placeholder="Enter recipient's email"
                />
              </div>
              <div className="cop-form-group">
                <label htmlFor="giftMessage">Personal Message (Optional)</label>
                <textarea
                  id="giftMessage"
                  value={giftMessage}
                  onChange={(e) => setGiftMessage(e.target.value)}
                  placeholder="Add a personal message..."
                  rows="4"
                />
              </div>
              <div className="cop-modal-footer">
                <button
                  type="button"
                  className="cop-modal-cancel"
                  onClick={() => setIsGiftModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="cop-modal-submit"
                  disabled={isGiftSubmitting}
                >
                  {isGiftSubmitting ? "Sending..." : "Send Gift"}
                </button>
              </div>
            </form> */}
          </div>
        </div>
      )}

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default CourseOverview;